<header [ngClass]="isHomePageNotScrolled ? 'fixedHeader_transparent' : 'fixedHeader'" [@headerAnimation]="isVisible ? 'visible' : 'hidden'">
    <div class="transparent_black_bg" *ngIf="showDropdown"></div>
    <div class="brand_logo">
        <img [src]="isHomePageNotScrolled ? 'assets/images/onehome_white.webp' : 'assets/images/DEMO.webp'" (click)="routeToHome()" alt="OneHomeLogo" />
        <img src="assets/images/DEMO.webp" style="display: none;" /> <!-- to remove flicker in change of image -->
        <!-- <img id="iifl_logo" src="assets/images/Group 48099631.webp" href="https://www.iiflhomeloans.com/" target="_blank" alt="HomeloanLogo" /> -->
    </div>
    <div class="main_nav">
    <!-- <div  class="nav_links" (click)="routeToHome()">Home</div> -->
        <div class="nav_links" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" style="width: 21ch;"(mouseenter)="showDropdown=true"  (mouseleave)="showDropdown=false" click="toggleDropdown()">Auction Properties <i class="bi bi-chevron-down"></i><i class="bi bi-chevron-up"></i>
            <div class="mega-dropdown" [class.show]="showDropdown">
                <div class="mega-dropdown__content">
                    <div class="mega-dropdown__row" > 
                        <div class="mega-dropdown__col">
                            <h6 >Popular Searches</h6>
                            <a [routerLink]="['/buy-auction-properties-in-delhi']" (click)="headerRouting('Delhi','2')">Apartments in Delhi</a>
                            <a [routerLink]="['/buy-auction-properties-in-palghar']" (click)="headerRouting('Palghar','2')">Apartments in Palghar</a>
                            <a [routerLink]="['/buy-auction-properties-in-thane']" (click)="headerRouting('Thane','2')">Apartments in Thane</a>
                            <a [routerLink]="['/buy-auction-properties-in-surat']" (click)="headerRouting('Surat','2')">Apartments in Surat</a>
                            <a [routerLink]="['/buy-auction-properties-in-raigad']" (click)="headerRouting('Raigad','2')">Apartments in Raigad</a>
                            <a [routerLink]="['/buy-auction-properties-in-ghaziabad']" (click)="headerRouting('Ghaziabad','2')">Apartments in Ghaziabad</a>
                            <a [routerLink]="['/buy-auction-properties-in-banagalore']" (click)="headerRouting('Bangalore','2')">Apartments in Bangalore</a>
                            <a [routerLink]="['/buy-auction-properties-in-lucknow']" (click)="headerRouting('Lucknow','2')">Apartments in Lucknow</a>
                            <a [routerLink]="['/buy-auction-properties-in-chennai']" (click)="headerRouting('Chennai','2')">Apartments in Chennai</a>
                        </div>
                        <div class="mega-dropdown__col">
                            <h6 >Budget Properties</h6>
                            <a [routerLink]="['/buy-properties-in-price-range-0-1000000']" (click)="headerPriceRouting('0','1000000','2')">Under 10 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-1000000-2000000']"(click)="headerPriceRouting('1000000','2000000','2')">10-20 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-2000000-3000000']"(click)="headerPriceRouting('2000000','3000000','2')">20-30 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-3000000-4000000']"(click)="headerPriceRouting('3000000','4000000','2')">30-40 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-4000000-5000000']"(click)="headerPriceRouting('4000000','5000000','2')">40-50 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-5000000-7500000']"(click)="headerPriceRouting('5000000','7500000','2')">50-75 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-7500000-10000000']"(click)="headerPriceRouting('7500000','10000000','2')">75 Lakhs-1 Crore</a>
                            <a [routerLink]="['/buy-properties-in-price-range-10000000-20000000']"(click)="headerPriceRouting('10000000','20000000','2')">1-2 Crores</a>
                            <a [routerLink]="['/buy-properties-in-price-range-20000000-500000000']"(click)="headerPriceRouting('20000000','500000000','2')">Above 2 Crore</a>
                        </div>
                        <!-- <div class="mega-dropdown__col">
                            <h6 >High Discount</h6>
                            <a [routerLink]="['/properties-in-discount-percent-range-50-100']" (click)="headerDiscountRouting(50,100,'2')">More than 50%</a>
                            <a [routerLink]="['/properties-in-discount-percent-range-40-100']" (click)="headerDiscountRouting(40,100,'2')">More than 40%</a>
                            <a [routerLink]="['/properties-in-discount-percent-range-30-100']" (click)="headerDiscountRouting(30,100,'2')">More than 30%</a>
                            <a [routerLink]="['/properties-in-discount-percent-range-20-100']" (click)="headerDiscountRouting(20,100,'2')">More than 20%</a>
                            <a [routerLink]="['/properties-in-discount-percent-range-10-100']" (click)="headerDiscountRouting(10,100,'2')">More than 10%</a>
                           </div> -->
                        <div (click) ="showDropdown=false" class="mega-dropdown__col" routerLink="/auction/info">
                            <h6><img src="assets/images/main_navdropdown.webp" alt="Auction Info"/></h6>
                            <a style="text-wrap: auto;" routerLink="/auction/info">
                                <b>How Auction Work</b><br/>
                                <span>Seamless digital auctions: register, bid, and pay online easily!</span>
                            </a>
                            <a  style="color: #FF5722;"  routerLink="/auction/info">Learn More <i class="fa fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav_links" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" style="width: 11ch;" (mouseenter)="showDropdown=true" (mouseleave)="showDropdown=false">Project <i class="bi bi-chevron-down"></i><i class="bi bi-chevron-up"></i>
            <div class="mega-dropdown" [class.show]="showDropdown">
                <div class="mega-dropdown__content">
                    <div class="mega-dropdown__row">
                        <div class="mega-dropdown__col">
                            <h6 >Popular Searches</h6>
                            <a [routerLink]="['/buy-properties-in-hyderabad']" (click)="headerRouting('Hyderabad','1')">Hyderabad</a>
                            <a [routerLink]="['/buy-properties-in-ambernath']" (click)="headerRouting('Ambernath','1')">Ambernath</a>
                            <a [routerLink]="['/buy-properties-in-pune']" (click)="headerRouting('Pune','1')">Pune</a>
                            <a [routerLink]="['/buy-properties-in-thane']" (click)="headerRouting('Thane','1')">Thane</a>
                            <a [routerLink]="['/buy-properties-in-gurgaon']" (click)="headerRouting('Gurgaon','1')">Gurugram</a>
                            <a [routerLink]="['/buy-properties-in-palghar']" (click)="headerRouting('Palghar','1')">Palghar</a>
                            <a [routerLink]="['/buy-properties-in-navi-mumbai']" (click)="headerRouting('Navi Mumbai','1')">Navi Mumbai</a>
                            <a [routerLink]="['/buy-properties-in-noida']" (click)="headerRouting('Noida','1')">Noida</a>
                            <a [routerLink]="['/buy-properties-in-ahmedabad']" (click)="headerRouting('Ahmedabad','1')">Ahmedabad</a>
                            <a [routerLink]="['/buy-properties-in-bangalore']" (click)="headerRouting('Bangalore','1')">Bangalore</a>
                        </div>
                        <div class="mega-dropdown__col">
                            <h6 >Top Projects</h6>
                        <ng-container *ngFor="let item of topTenProjectsList">
                            <a *ngIf="item.projectName && item.projectName.trim() !== ''" (click)="redirectTopProject(item.url)">
                                {{ item.projectName }}
                            </a>
                        </ng-container>


                             <!-- <a [routerLink]="['/buy-properties-in-northstar-sanctuary']" (click)="headerProjectRouting('Northstar Sanctuary','1')">Northstar Sanctuary</a>
                        <a [routerLink]="['/buy-properties-in-panvelkar-greens-phase-i']" (click)="headerProjectRouting('Panvelkar Greens Phase I','1')">Panvelkar Greens Phase I</a>
                        <a [routerLink]="['/buy-properties-in-vasavi-archana-white']" (click)="headerProjectRouting('Vasavi Archana White','1')">Vasavi Archana White Lotus</a>
                        <a [routerLink]="['/buy-properties-in-riverwood-park']"  (click)="headerProjectRouting('Riverwood Park','1')">Riverwood Park</a>
                        <a [routerLink]="['/buy-properties-in-doon']"  (click)="headerProjectRouting('Doon','1')">Doon Boulevard</a>
                        <a [routerLink]="['/buy-properties-in-rajvik']" (click)="headerProjectRouting('Rajvik','1')">Rajvik Greens</a>
                        <a [routerLink]="['/buy-properties-in-rof-atulyas']"  (click)="headerProjectRouting('Rof Atulyas','1')">Rof Atulyas</a>
                        <a [routerLink]="['/buy-properties-in-e11-evolve']" (click)="headerProjectRouting('E11 Evolve','1')">E11 Evolve</a> -->
                        </div>
                        <div class="mega-dropdown__col">
                            <h6 >Price Range</h6>
                            <a [routerLink]="['/buy-properties-in-price-range-0-1000000']" (click)="headerPriceRouting('0','1000000','1')">Under 10 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-1000000-2000000']" (click)="headerPriceRouting('1000000','2000000','1')">10-20 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-2000000-3000000']" (click)="headerPriceRouting('2000000','3000000','1')">20-30 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-3000000-4000000']" (click)="headerPriceRouting('3000000','4000000','1')">30-40 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-4000000-5000000']" (click)="headerPriceRouting('4000000','5000000','1')">40-50 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-5000000-7500000']" (click)="headerPriceRouting('5000000','7500000','1')">50-75 Lakhs</a>
                            <a [routerLink]="['/buy-properties-in-price-range-7500000-10000000']" (click)="headerPriceRouting('7500000','10000000','1')">75 Lakhs-1 Crore</a>
                            <a [routerLink]="['/buy-properties-in-price-range-10000000-20000000']" (click)="headerPriceRouting('10000000','20000000','1')">1-2 Crores</a>
                            <a [routerLink]="['/buy-properties-in-price-range-20000000-500000000']" (click)="headerPriceRouting('20000000','500000000','1')">Above 2 Crore</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="nav_links" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" style="width: 13ch;" (mouseenter)="showDropdown=true" (mouseleave)="showDropdown=false">Insights <i class="bi bi-chevron-down normal"></i><i class="bi bi-chevron-up hover"></i>
            <div class="mega-dropdown" [class.show]="showDropdown">
                <div class="mega-dropdown__content">
                    <div class="mega-dropdown__row"> 
                        <div class="mega-dropdown__col">
                            <h6 >All Articles</h6>
                            <a (click)="headerArticleHide('Knowledge Hub')" routerLink="/knowledge-hub">Knowledge Hub</a>
                            <!-- <a (click)="headerArticleHide('Blogs')" routerLink="/blog/list"  [queryParams]="{selectedBlogCat:'blogs'}" >Blogs</a>
                            <a (click)="headerArticleHide('News')" routerLink="/blog/list" [queryParams]="{selectedBlogCat:'news'}">News</a> -->
                            <a (click)="headerArticleHide('Blogs')" routerLink="/blog/list"  >Blogs</a>
                            <a (click)="headerArticleHide('News')" routerLink="/blog/news">News</a>
                            <!-- <a (click)="headerArticleHide('City Updates')" routerLink="/blog/list"  [queryParams]="{selectedBlogCat:'city update'}">City Update</a> -->
                            <a (click)="headerArticleHide('FAQs')" routerLink="/faq" >FAQs</a>
                            <a (click)="openUserGuide($event)" target="_blank" rel="noopener noreferrer">User Guide</a>
                            <a (click)="headerArticleHide('Home Buying Guide')" routerLink="/home-buying-guide">Home Buying Guide</a>
                            <a (click)="headerArticleHide('Glossary')" routerLink="/glossary">Glossary</a>
                            <a (click)="headerArticleHide('city-news-update')" routerLink="/city-news-update">City News Update</a>
                            <!-- <a (click)="headerArticleHide('City-Info')" routerLink="/city-info">City Update</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  class="nav_links" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" routerLink="/about-us">About Us</div>
    </div>
    <div class="right_div">
        <!-- <a href="mailto:care@iiflonehome.com" *ngIf="!ismobile" (click)="gaPushLayer('mailto:care@iiflonehome.com')"><img src="assets/images/mail.svg" alt="mail @ care@iiflonehome.com"></a>
        <a href="tel:1800-2672-499" *ngIf="!ismobile" (click)="gaPushLayer('tel:1800-2672-499')"><img src="assets/images/phone.svg" alt="Call 1800-2672-499"></a> -->
        <div  class="nav_links CU" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" routerLink="/contact-us">Contact-Us</div>
        <!-- ---------------------------- notification dd start ----------------------------------------->
         <div *ngIf="isAuth">
             <app-notification [isHomePageNotScrolled]="isHomePageNotScrolled"></app-notification>
         </div>
         <!-- <div class="nav_links" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" style="width: 2ch;" (mouseenter)="showDropdown=true" (mouseleave)="showDropdown=false">
        <img *ngIf="!isAuth" src="../../../assets/images/notification_bell.png" class="notification-img" alt="notification_img"/>  
            <div class="mega-dropdown notification-mega-dropdown " [class.show]="showDropdown">
                <div class="mega-dropdown__content">
                    <div class="mega-dropdown__row"> 
                        <div class="mega-dropdown__col">
                            <h6 >Notifications</h6>
                            <div class="notification-div">
                             <img src="../../../assets/images/notification_bell.png" class="notification-img" alt="notification_img"/>
                             <div>
                                 <p><strong>Successfully updated profile</strong></p>
                                 <p>Your changes have been saved and your profile is live. Your team can make edits.</p>
                                </div>
                            </div>
                            <a (click)="headerArticleHide('Blogs')" routerLink="/blog/list"  [queryParams]="{selectedBlogCat:'blogs'}" >Blogs</a>
                            <a (click)="headerArticleHide('News')" routerLink="/blog/list" [queryParams]="{selectedBlogCat:'news'}">News</a>
                            <a (click)="headerArticleHide('City Updates')" routerLink="/blog/list"  [queryParams]="{selectedBlogCat:'city update'}">City Update</a>
                            <a (click)="headerArticleHide('FAQs')" routerLink="/faq" >FAQs</a>
                            <a (click)="headerArticleHide('User Guide')" href="{{URL}}" target="_blank" rel="noopener noreferrer">User Guide</a>
                            <a (click)="headerArticleHide('Home Buying Guide')" routerLink="/home-buying-guide">Home Buying Guide</a>
                            <a (click)="headerArticleHide('Glossary')" routerLink="/glossary">Glossary</a>
                            <a (click)="headerArticleHide('Knowledge Hub')" routerLink="/knowledge-hub">Knowledge Hub</a>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- ---------------------------- notification dd end ------------------------------------------->

        <button *ngIf="!isAuth" class="btn btn-warning btn-block headerreg" 
            href="#offcanvasTopSignin" data-bs-toggle="offcanvas">Login
        </button>
        <div *ngIf="isAuth" class="nav_links" 
        [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085' }" 
        (mouseenter)="showDropdown=true"(mouseleave)="showDropdown=false"> 
            <div class="d-none d-md-flex" [ngStyle]="{ width: (loggedInUserData.firstName.length + loggedInUserData.lastName.length + 6) + 'ch' }" >
                <img src="{{(loggedInUserData?.profileImg ||'assets/images/user-pic.webp') +token}}" class="user_img" alt="Profic Image"/>
                <span class="show-name">{{loggedInUserData.firstName}}{{loggedInUserData.lastName}}&nbsp;</span>
                <i class="bi bi-chevron-down"></i><i class="bi bi-chevron-up"></i>
            </div>
            <div class="avatar d-flex d-md-none" 
                [title]="loggedInUserData.firstName + ' ' + loggedInUserData.lastName">
                {{ loggedInUserData.firstName.charAt(0) + loggedInUserData.lastName.charAt(0) }}
            </div>
            <div class="mega-dropdown" [class.show]="showDropdown" style="right: 0;">
                <div class="mega-dropdown__content">
                    <div class="mega-dropdown__row"> 
                        <div class="mega-dropdown__col">
                            <a (click)="ctaClickEvent('My Profile')"routerLink="/profile"><span>MyProfile</span></a>
                            <a (click)="ctaClickEvent('Recent Searches')"[routerLink]="['/container/recently-search']"><span>Recent Searches</span></a>
                            <a (click)="ctaClickEvent('Viewed Properties')"[routerLink]="['/container/recently-view']"><span>Viewed Properties</span></a>
                            <a (click)="ctaClickEvent('Saved Properties')" [routerLink]="['/container/saved']"><span>Saved Properties</span></a>
                            <a (click)="ctaClickEvent('My Bids')" [routerLink]="['/auction/bids']"><span>My Bids</span></a>
                            <a (click)="logout()" href=""><span>Logout</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="navhamburger" href="#offcanvasRightMenu" data-bs-toggle="offcanvas" aria-label="Open navigation menu">
        <i class="fa fa-navicon" [ngStyle]="{ 'color': isHomePageNotScrolled ? 'white' : '#667085'}"></i> </a>
    </div>  
</header>
<!--Menu offcanvas-->
<div *ngIf="alertRibbonData && alertRibbonData.length > 0 && isHomePage">
    <app-alert-ribbon [alertRibbonData]="alertRibbonData"></app-alert-ribbon>
</div>


<div class="offcanvas offcanvas-end navmenu-offcanvas" tabindex="-1" id="offcanvasRightMenu"
    aria-labelledby="offcanvasRightLabel" >
    <div class="offcanvas-header">
        <h5 id="offcanvasRightLabel">Menu</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <ul class="list-unstyled right_menu">
            <li class="dropdown">
                <a href="#PAS" data-bs-toggle="collapse">Popular Auction Searches<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="PAS">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a [routerLink]="['/buy-auction-properties-in-delhi']" (click)="headerRouting('Delhi','2')">Apartments in Delhi</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-palghar']" (click)="headerRouting('Palghar','2')">Apartments in Palghar</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-thane']" (click)="headerRouting('Thane','2')">Apartments in Thane</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-surat']" (click)="headerRouting('Surat','2')">Apartments in Surat</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-raigad']" (click)="headerRouting('Raigad','2')">Apartments in Raigad</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-ghaziabad']" (click)="headerRouting('Ghaziabad','2')">Apartments in Ghaziabad</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-banagalore']" (click)="headerRouting('Bangalore','2')">Apartments in Bangalore</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-lucknow']" (click)="headerRouting('Lucknow','2')">Apartments in Lucknow</a></li>
                        <li><a [routerLink]="['/buy-auction-properties-in-chennai']" (click)="headerRouting('Chennai','2')">Apartments in Chennai</a></li>
                    </ul>
                </div>
            </li>
            <li class="dropdown">
                <a href="#BAP" data-bs-toggle="collapse">Budgeted Auction Properties<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="BAP">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a [routerLink]="['/buy-properties-in-price-range-0-1000000']" (click)="headerPriceRouting('0','1000000','2')">Under 10 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-1000000-2000000']"(click)="headerPriceRouting('1000000','2000000','2')">10-20 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-2000000-3000000']"(click)="headerPriceRouting('2000000','3000000','2')">20-30 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-3000000-4000000']"(click)="headerPriceRouting('3000000','4000000','2')">30-40 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-4000000-5000000']"(click)="headerPriceRouting('4000000','5000000','2')">40-50 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-5000000-7500000']"(click)="headerPriceRouting('5000000','7500000','2')">50-75 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-7500000-10000000']"(click)="headerPriceRouting('7500000','10000000','2')">75 Lakhs-1 Crore</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-10000000-20000000']"(click)="headerPriceRouting('10000000','20000000','2')">1-2 Crores</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-20000000-500000000']"(click)="headerPriceRouting('20000000','500000000','2')">Above 2 Crore</a></li>
                    </ul>
                </div>
            </li>
            <!-- <li class="dropdown">
                <a href="#DAP" data-bs-toggle="collapse">Discounted Auction Properties<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="DAP">
                    <ul class="list-unstyled right_menu right_drop_menu">
                    <li><a [routerLink]="['/properties-in-discount-percent-range-50-100']" (click)="headerDiscountRouting(50,100,'2')">More than 50%</a></li>
                    <li><a [routerLink]="['/properties-in-discount-percent-range-40-100']" (click)="headerDiscountRouting(40,100,'2')">More than 40%</a></li>
                    <li><a [routerLink]="['/properties-in-discount-percent-range-30-100']" (click)="headerDiscountRouting(30,100,'2')">More than 30%</a></li>
                    <li><a [routerLink]="['/properties-in-discount-percent-range-20-100']" (click)="headerDiscountRouting(20,100,'2')">More than 20%</a></li>
                    <li><a [routerLink]="['/properties-in-discount-percent-range-10-100']" (click)="headerDiscountRouting(10,100,'2')">More than 10%</a></li>
                    </ul>
                </div>
            </li> -->
            <li class="dropdown"><a (click)="hideMenu()" routerLink="/auction/info">How Auction Works</a></li>            
            <li class="dropdown">
                <a href="#PP" data-bs-toggle="collapse">Popular Projects<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="PP">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a [routerLink]="['/buy-properties-in-hyderabad']" (click)="headerRouting('Hyderabad','1')">Hyderabad</a></li>
                        <li><a [routerLink]="['/buy-properties-in-ambernath']" (click)="headerRouting('Ambernath','1')">Ambernath</a></li>
                        <li><a [routerLink]="['/buy-properties-in-pune']" (click)="headerRouting('Pune','1')">Pune</a></li>
                        <li><a [routerLink]="['/buy-properties-in-thane']" (click)="headerRouting('Thane','1')">Thane</a></li>
                        <li><a [routerLink]="['/buy-properties-in-gurgaon']" (click)="headerRouting('Gurgaon','1')">Gurugram</a></li>
                        <li><a [routerLink]="['/buy-properties-in-palghar']" (click)="headerRouting('Palghar','1')">Palghar</a></li>
                        <li><a [routerLink]="['/buy-properties-in-navi-mumbai']" (click)="headerRouting('Navi Mumbai','1')">Navi Mumbai</a></li>
                        <li><a [routerLink]="['/buy-properties-in-noida']" (click)="headerRouting('Noida','1')">Noida</a></li>
                        <li><a [routerLink]="['/buy-properties-in-ahmedabad']" (click)="headerRouting('Ahmedabad','1')">Ahmedabad</a></li>
                        <li><a [routerLink]="['/buy-properties-in-bangalore']" (click)="headerRouting('Bangalore','1')">Bangalore</a></li>
                    </ul>
                </div>
            </li>
            <li class="dropdown">
                <a href="#TP" data-bs-toggle="collapse">Top Projects<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="TP">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        
                        <ng-container *ngFor="let item of topTenProjectsList">
                            <a *ngIf="item.projectName && item.projectName.trim() !== ''" (click)="redirectTopProject(item.url)">
                                {{ item.projectName }}
                            </a>
                        </ng-container>

                        <!-- <li><a [routerLink]="['/buy-properties-in-northstar-sanctuary']" (click)="headerProjectRouting('Northstar Sanctuary','1')">Northstar Sanctuary</a></li>
                        <li><a [routerLink]="['/buy-properties-in-panvelkar-greens-phase-i']" (click)="headerProjectRouting('Panvelkar Greens Phase I','1')">Panvelkar Greens Phase I</a></li>
                        <li><a [routerLink]="['/buy-properties-in-vasavi-archana-white']" (click)="headerProjectRouting('Vasavi Archana White','1')">Vasavi Archana White Lotus</a></li>
                        <li><a [routerLink]="['/buy-properties-in-riverwood-park']"  (click)="headerProjectRouting('Riverwood Park','1')">Riverwood Park</a></li>
                        <li><a [routerLink]="['/buy-properties-in-doon']"  (click)="headerProjectRouting('Doon','1')">Doon Boulevard</a></li>
                        <li><a [routerLink]="['/buy-properties-in-rajvik']" (click)="headerProjectRouting('Rajvik','1')">Rajvik Greens</a></li>
                        <li><a [routerLink]="['/buy-properties-in-rof-atulyas']"  (click)="headerProjectRouting('Rof Atulyas','1')">Rof Atulyas</a></li>
                        <li><a [routerLink]="['/buy-properties-in-e11-evolve']" (click)="headerProjectRouting('E11 Evolve','1')">E11 Evolve</a></li> -->
                    </ul>
                </div>
            </li>
            <li class="dropdown">
                <a href="#BP" data-bs-toggle="collapse">Projects as per your Budget<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="BP">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a [routerLink]="['/buy-properties-in-price-range-0-1000000']" (click)="headerPriceRouting('0','1000000','1')">Under 10 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-1000000-2000000']" (click)="headerPriceRouting('1000000','2000000','1')">10-20 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-2000000-3000000']" (click)="headerPriceRouting('2000000','3000000','1')">20-30 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-3000000-4000000']" (click)="headerPriceRouting('3000000','4000000','1')">30-40 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-4000000-5000000']" (click)="headerPriceRouting('4000000','5000000','1')">40-50 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-5000000-7500000']" (click)="headerPriceRouting('5000000','7500000','1')">50-75 Lakhs</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-7500000-10000000']" (click)="headerPriceRouting('7500000','10000000','1')">75 Lakhs-1 Crore</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-10000000-20000000']" (click)="headerPriceRouting('10000000','20000000','1')">1-2 Crores</a></li>
                        <li><a [routerLink]="['/buy-properties-in-price-range-20000000-500000000']" (click)="headerPriceRouting('20000000','500000000','1')">Above 2 Crore</a></li>
                    </ul>
                </div>
            </li>
            <li class="dropdown">
                <a href="#KH" data-bs-toggle="collapse">Insights<span class="fa fa-angle-right"></span></a>
                <div class="collapse" id="KH">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a (click)="headerArticleHide('Knowledge Hub')" routerLink="/knowledge-hub">Knowledge Hub</a></li>
                        <!-- <li><a (click)="headerArticleHide('Blogs')" routerLink="/blog/list"  [queryParams]="{selectedBlogCat:'blogs'}" >Blogs</a></li>
                        <li><a (click)="headerArticleHide('News')" routerLink="/blog/list" [queryParams]="{selectedBlogCat:'news'}">News</a></li> -->
                        <a (click)="headerArticleHide('Blogs')" routerLink="/blog/list"  >Blogs</a>
                            <a (click)="headerArticleHide('News')" routerLink="/blog/news">News</a>
                        <!-- <li><a (click)="headerArticleHide('City Updates')" routerLink="/blog/list"  [queryParams]="{selectedBlogCat:'city update'}">City Update</a></li> -->
                        <li><a (click)="headerArticleHide('FAQ')" routerLink="/faq" >FAQs</a></li>
                        <li><a (click)="openUserGuide($event)" target="_blank" rel="noopener noreferrer">User Guide</a></li>
                        <li><a (click)="headerArticleHide('Home Buying Guide')" routerLink="/home-buying-guide">Home Buying Guide</a></li>
                        <li><a (click)="headerArticleHide('Glossary')" routerLink="/glossary">Glossary</a></li>
                        <a (click)="headerArticleHide('city-news-update')" routerLink="/city-news-update">City News Update</a>
                            <!-- <a (click)="headerArticleHide('City Page')" routerLink="/city-page">City Page</a> -->
                        <!-- <li><a (click)="headerArticleHide('City-Info')" routerLink="/city-info">City Update</a></li> -->
                    </ul>
                </div>
            </li>
            <li class="dropdown"><a (click)="hideMenu()" [routerLink]="['/about-us']">About Us</a></li>
            <!-- <li class="dropdown"><a href="#Buyhomecollapse" data-bs-toggle="collapse">Buy home <span
                        class="fa fa-angle-right"></span></a>
                <div class="collapse" id="Buyhomecollapse">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a href="" (click)="hideOffcanvasRightMenu('Buy home','Get started')"
                                routerLink="/get-start" *ngIf="isAuth"> Get started</a></li>
                        <li><a href=""
                               (click)="hideOffcanvasRightMenu('Buy home','Search Properties')"
                                [routerLink]="['/property/list']">Search Properties</a></li>
                    </ul>
                </div>
            </li>
            <li class="dropdown"><a href="#Auctioncollapse" data-bs-toggle="collapse">Auction <span
                        class="fa fa-angle-right"></span></a>
                <div class="collapse" id="Auctioncollapse">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a href="" (click)="hideOffcanvasRightMenu('Auction','How to Bid')"
                                [routerLink]="['/auction/info']">How to Bid</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Auction','Browse Properties')"
                                routerLink="/property/list" [queryParams]="{tab:'auction'}">Browse Properties</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Auction','My Bids')"
                                [routerLink]="['/auction/bids']" *ngIf="isAuth">My Bids</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Auction','Visited Auction')"
                                [routerLink]="['/auction/visited']" *ngIf="isAuth">Visited Auction</a></li>
                    </ul> 
                </div>
            </li>
            <li class="dropdown"><a href="#QuickLinkscollapse" data-bs-toggle="collapse">Quick Links <span
                        class="fa fa-angle-right"></span></a>
                <div class="collapse" id="QuickLinkscollapse">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a href="https://www.iiflhomeloans.com/" target="_blank"
                               (click)="ctaClickEventHam('Quick Links', 'Home Loans')">Home Loans</a></li>
                        <li><a href="https://www.iiflhomeloans.com/home-loan-emi-calculator" target="_blank"
                               (click)="ctaClickEventHam('Quick Links', 'EMI Calculator')">EMI
                                Calculator</a></li>
                        <li><a href="https://customerportal.iifl.com/home-loan-eligibility/?utm_source=WebsiteHFL&utm_subsource=ProductsHL_Exp"
                                target="_blank" (click)="ctaClickEventHam('Quick Links', 'Home Loan Eligibility')">Home
                                Loan Eligibility</a></li>
                    </ul>
                </div>
            </li>
            <li class="dropdown"><a href="#KnowledgeHubcollapse" data-bs-toggle="collapse">Knowledge Hub <span
                        class="fa fa-angle-right"></span></a>
                <div class="collapse" id="KnowledgeHubcollapse">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a href="" (click)="hideOffcanvasRightMenu('Knowledge Hub','News')"
                                routerLink="/blog/list" [queryParams]="{selectedBlogCat:'news'}">News</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Knowledge Hub','Blogs')"
                                routerLink="/blog/list" [queryParams]="{selectedBlogCat:'blogs'}">Blogs</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Knowledge Hub','FAQs')"
                                routerLink="/faq">FAQs</a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="dropdown"><a href="#Companycollapse" data-bs-toggle="collapse">Company <span
                        class="fa fa-angle-right"></span></a>
                <div class="collapse" id="Companycollapse">
                    <ul class="list-unstyled right_menu right_drop_menu">
                        <li><a href="" (click)="hideOffcanvasRightMenu('Company','About Us')"
                                routerLink="/about-us">
                                About Us</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Company','Contact')"
                                routerLink="/contact-us">Contact</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Company','Privacy Policy')"
                                routerLink="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Company','Term & Conditions')"
                                routerLink="/terms-conditions">Term & Conditions</a></li>
                        <li><a href="" (click)="hideOffcanvasRightMenu('Company','Disclaimer')"
                                routerLink="/disclaimer">Disclaimer</a></li>
                    </ul>
                </div>
            </li> -->

        </ul>
    </div>
</div>
<!-- Menu offcanvas End-->

<!-- User First Login offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" data-bs-scroll="true" tabindex="-1" id="offcanvasToplogin"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/new_loginimg.webp" alt="Login Banner" />
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <form action="#">
                                <div class="form-group">
                                    <a href="#offcanvasTopSignin" data-bs-toggle="offcanvas"
                                        class="btn btn-warning btn-block">Sign in</a>
                                </div>

                                <div class="form-group">
                                    <a href="#offcanvasTopRegister" data-bs-toggle="offcanvas"
                                        class="btn btn-outline-warning btn-block">Create Your Account</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- User First Login offcanvas End-->

<!-- Login offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" tabindex="-1" id="offcanvasTopSignin" data-bs-scroll="true"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <div class="back-link d-flex align-items-center">
           <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/login-banner-mobile.webp" *ngIf="ismobile" alt="Login Banner"/>
                        <img src="assets/images/new_loginimg.webp" *ngIf="!ismobile" alt="Login Banner"/>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <div class="title">
                                <h3>Login</h3>
                            </div>
                            <form [formGroup]="loginForm" (keyup.enter)="nextToPasswordOtp()">
                                <div class="form-group"
                                    *ngIf="!loginForm.value.hasOwnProperty('mobile')&&!loginForm.value.hasOwnProperty('email')">
                                    <input type="text" #emailMobile class="form-ctrl form-control"
                                        placeholder="Enter Email ID/ Mobile No." (keyup)="isMobile($event,loginForm)" autocomplete="new-password">
                                </div>
                                <div class="row" *ngIf="loginForm.value.hasOwnProperty('mobile')">
                                    <div class="col-4 col-sm-3 col-md-4 col-lg-3">
                                        <div class="form-group">
                                            <select class="form-ctrl form-control" formControlName="countryCode">
                                                <option value="91">+91</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-8 col-sm-9 col-md-8 col-lg-9">
                                        <div class="form-group">
                                            <input type="tel" #mobile formControlName="mobile"
                                                class="form-ctrl form-control" placeholder="123"
                                               (keyup)="isMobile($event,loginForm)"
                                                [ngClass]="{ 'is-invalid': loginSubmitted && loginFormControls['mobile'].errors }">
                                            <div *ngIf="loginSubmitted && loginFormControls['mobile'].errors"
                                                class="invalid-feedback">
                                                <div *ngIf="loginFormControls['mobile'].errors['required']">
                                                    Mobile No. is required.
                                                </div>
                                                <div *ngIf="loginFormControls['mobile'].errors['pattern']">
                                                    Mobile No. should be valid.
                                                </div>
                                            </div>
                                            <div style="display: block;" class="invalid-feedback">
                                                <div *ngIf="!isUserExist">
                                                    {{errorMsg}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="loginForm.value.hasOwnProperty('email')">
                                    <input type="email" formControlName="email" class="form-ctrl form-control"
                                        placeholder="Enter Email ID" #email (keyup)="isMobile($event,loginForm)"
                                        [ngClass]="{ 'is-invalid': loginSubmitted && loginFormControls['email'].errors }" autocomplete="new-password">
                                    <div *ngIf="loginSubmitted && loginFormControls['email'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="loginFormControls['email'].errors['required']">
                                            Email is required.
                                        </div>
                                        <div *ngIf="loginFormControls['email'].errors['email']">
                                            Email should be valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button (click)="nextToPasswordOtp()" [disabled]="isSendOtpDisabled"
                                        class="btn btn-warning btn-block">Continue</button>
                                </div>
                                <p class="text-left" style="color: #555;">
                                    Don't have an account yet? 
                                    <a href="#offcanvasTopRegister" data-bs-toggle="offcanvas" style="color: #ef5713; text-decoration: underline;">Create one now</a>.
                                  </p>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Login offcanvas End-->

<!--  Password offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" tabindex="-1" id="offcanvasTopPassword"
    aria-labelledby="offcanvasTopLabel" data-bs-scroll="true">
    <div class="offcanvas-body">
        <div class="back-link d-flex align-items-center">
            <a href="#offcanvasTopSignin" style="position: absolute;top: 15px;left: 460px;z-index: 1;"
                data-bs-toggle="offcanvas">
                <img class="img-fluid mr-1" src="assets/images/back-arrow.webp" alt="Back"/></a>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/new_loginimg.webp" alt="Login Banner"/>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <div class="title">
                                <h3>Password</h3>
                            </div>
                            <form [formGroup]="loginForm" (ngSubmit)="loginByEmail()">
                                <div class="form-group" *ngIf="loginForm.value.hasOwnProperty('password')">
                                    <label>Enter your password for <strong>{{loginForm.value.email}}</strong></label>
                                    <input #signInPassword type="password" formControlName="password"
                                        class="form-ctrl form-control" placeholder="Enter Password" autocomplete="current-password" 
                                        [ngClass]="{ 'is-invalid': loginSubmitted && loginFormControls['password'].errors }">
                                    <div *ngIf="loginSubmitted && loginFormControls['password'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="loginFormControls['password'].errors['required']">
                                            Password is required
                                        </div>
                                    </div>
                                    <div style="display: block;" class="invalid-feedback">
                                        <div *ngIf="!isPasswordCorrect">
                                            Wrong Password
                                        </div>
                                    </div>
                                    <div class="form_icon"
                                       (click)="signInPassword.type=signInPassword.type=='password'?'text':'password'">
                                        <span toggle="#password-field"
                                            [ngClass]="signInPassword.type=='password'?'fa-eye-slash':'fa-eye'"
                                            class="fa fa-fw field-icon toggle-password"></span>
                                    </div>
                                </div>
                                <div class="form-group forgot-txt">
                                    <p class="txt-rgt">
                                        <a href="#" (click)="showForotpasswordModal()">
                                            Forgot  Password?</a>
                                    </p>
                                </div>
                                <div class="form-group">
                                    <button href=""
                                        class="btn btn-warning btn-block">Login</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Password offcanvas End-->

<!--  Number Login offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" tabindex="-1" id="offcanvasTopNoLogin"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/new_loginimg.webp" alt="Login Banner"/>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <div class="title">
                                <h3>Forgot Password</h3>
                            </div>
                            <form [formGroup]="otpForm" (keyup.enter)="sendOtp()">
                                <div class="form-group"
                                    *ngIf="!otpForm.value.hasOwnProperty('mobile')&&!otpForm.value.hasOwnProperty('email')">
                                    <input type="text" #emailMobile class="form-ctrl form-control"
                                        placeholder="Enter Email ID/ Mobile No." (keyup)="isMobile($event,otpForm)" autocomplete="new-password">
                                </div>
                                <div class="row" *ngIf="otpForm.value.hasOwnProperty('mobile')">
                                    <div class="col-4 col-sm-3 col-md-4 col-lg-3">
                                        <div class="form-group">
                                            <select class="form-ctrl form-control" formControlName="countryCode">
                                                <option value="91">+91</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-8 col-sm-9 col-md-8 col-lg-9">
                                        <div class="form-group">
                                            <input type="tel" #mobile formControlName="mobile"
                                                class="form-ctrl form-control" placeholder="123"
                                               (keyup)="isMobile($event,otpForm)"
                                                [ngClass]="{ 'is-invalid': otpFormSubmitted && otpFormControls['mobile'].errors }">
                                            <div *ngIf="otpFormSubmitted && otpFormControls['mobile'].errors"
                                                class="invalid-feedback">
                                                <div *ngIf="otpFormControls['mobile'].errors['required']">
                                                    Mobile No. is required.
                                                </div>
                                                <div *ngIf="otpFormControls['mobile'].errors['pattern']">
                                                    Mobile No. should be valid.
                                                </div>
                                            </div>
                                            <div style="display: block;" class="invalid-feedback">
                                                <div *ngIf="!isUserExist">
                                                    {{errorMsg}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="otpForm.value.hasOwnProperty('email')">
                                    <input type="email" formControlName="email" class="form-ctrl form-control"
                                        placeholder="Enter Email ID" #email (keyup)="isMobile($event,otpForm)"
                                        [ngClass]="{ 'is-invalid': otpFormSubmitted && otpFormControls['email'].errors }" autocomplete="new-password">
                                    <div *ngIf="otpFormSubmitted && otpFormControls['email'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="otpFormControls['email'].errors['required']">
                                            Email is required.
                                        </div>
                                        <div *ngIf="otpFormControls['email'].errors['email']">
                                            Email should be valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button href="" (click)="sendOtp()"
                                        class="btn btn-warning btn-block">Continue</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Number Login offcanvas End-->

<!--  OTP offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" tabindex="-1" id="offcanvasTopOTP"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <div class="back-link d-flex align-items-center">
            <a href="#offcanvasTopSignin" style="position: absolute;top: 15px;left: 460px;z-index: 1;"
                data-bs-toggle="offcanvas">
                <img class="img-fluid mr-1" src="assets/images/back-arrow.webp" alt="Back"/></a>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/login-banner-mobile.webp" *ngIf="ismobile" alt="Login Banner"/>
                        <img src="assets/images/new_loginimg.webp" *ngIf="!ismobile" alt="Login Banner" />
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <div class="title">
                                <h3>OTP</h3>
                            </div>
                            <form [formGroup]="loginForm" (ngSubmit)="verifyOtp()">

                                <p>Enter OTP sent to your Mobile Number</p>
                                <div class="d-flex justify-content-between">
                                    <p><strong>+{{loginForm.value.countryCode}} {{loginForm.value.mobile}}</strong></p>
                                    <p>
                                        <a href="" href="#offcanvasTopSignin"
                                            data-bs-toggle="offcanvas">
                                            <img src="assets/images/pencil.webp" class="img-fluid" alt="Edit"/>
                                        </a>
                                    </p>
                                </div>

                                <div class="form-group" *ngIf="loginForm.value.hasOwnProperty('otp')">
                                    <input type="number" class="form-ctrl form-control" placeholder="Enter OTP"
                                        formControlName="otp"
                                        [ngClass]="{ 'is-invalid': loginSubmitted && loginFormControls['otp'].errors }">
                                    <div *ngIf="loginSubmitted && loginFormControls['otp'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="loginFormControls['otp'].errors['required']">
                                            OTP is required
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="form-group">
                                    <button href="" (click)="verifyOtp()"
                                        class="btn btn-warning btn-block">Login</button>
                                </div> -->
                                    <div class="form-group">
                                      <button type="submit" class="btn btn-warning btn-block">Login</button>
                                    </div>
                                  </form>
                                <!-- <div class="or"><span>OR</span></div> -->
                                <div class="form-group SignUp-txt text-start">
                                    <!-- <p><a href="#"> Click Here</a> to verify via missed call from your number
                                       (+{{loginForm.value.countryCode}} {{loginForm.value.mobile}}) </p> -->
                                </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- OTP offcanvas End-->

<!-- Register offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" tabindex="-1" id="offcanvasTopRegister"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <button type="button" class="btn-close text-reset" (click)="hideRegisterOffCanvas()"
            aria-label="Close"></button>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/new_loginimg.webp" *ngIf="!ismobile" alt="Login Banner"/>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <div class="title">
                                <h3>Register</h3>
                            </div>
                            <form [formGroup]="registerForm" (ngSubmit)="registerSendOtp()">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <input type="text" formControlName="firstName"
                                                class="form-ctrl form-control"
                                                onkeypress="return /[a-zA-Z]/i.test(event.key)" placeholder="First Name"
                                                [ngClass]="{ 'is-invalid': registerSubmitted && registerFormControls['firstName'].errors }">
                                            <div *ngIf="registerSubmitted && registerFormControls['firstName'].errors"
                                                class="invalid-feedback">
                                                <div *ngIf="registerFormControls['firstName'].errors['required']">
                                                    First Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <input type="text" formControlName="lastName" class="form-ctrl form-control"
                                                placeholder="Last name" onkeypress="return /[a-zA-Z]/i.test(event.key)"
                                                [ngClass]="{ 'is-invalid': registerSubmitted && registerFormControls['lastName'].errors }">
                                            <div *ngIf="registerSubmitted && registerFormControls['lastName'].errors"
                                                class="invalid-feedback">
                                                <div *ngIf="registerFormControls['lastName'].errors['required']">
                                                    Last Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="form-group"> -->
                                <div class="row" >
                                    <div class="col-4 col-sm-3 col-md-4 col-lg-3">
                                        <div class="form-group">
                                            <select class="form-ctrl form-control" formControlName="countryCode">
                                                <option value="91">+91</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-8 col-sm-9 col-md-8 col-lg-9">
                                        <div class="form-group">
                                            <input type="number" formControlName="mobile" class="form-ctrl form-control"
                                                placeholder="Mobile no"
                                                [ngClass]="{ 'is-invalid': registerSubmitted && registerFormControls['mobile'].errors }">
                                            <div *ngIf="registerSubmitted && registerFormControls['mobile'].errors"
                                                class="invalid-feedback">
                                                <div *ngIf="registerFormControls['mobile'].errors['required']">
                                                    Mobile No. is required
                                                </div>
                                                <div *ngIf="registerFormControls['mobile'].errors['pattern']">
                                                    Mobile No. should be valid.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- </div> -->
                                <div class="form-group">
                                    <input type="text" formControlName="email" class="form-ctrl form-control"
                                        placeholder="Email ID"
                                        [ngClass]="{ 'is-invalid': registerSubmitted && registerFormControls['email'].errors }" autocomplete="new-password">
                                    <div *ngIf="registerSubmitted && registerFormControls['email'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="registerFormControls['email'].errors['required']">
                                            Email is required.
                                        </div>
                                        <div *ngIf="registerFormControls['email'].errors['email']">
                                            Email should be valid.
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input #registerPassword id="password-field" formControlName="password"
                                        type="password" class="form-control form-ctrl" name="password"
                                        placeholder="Create password" autocomplete="new-password"
                                        [ngClass]="{ 'is-invalid': registerSubmitted && registerFormControls['password'].errors }">
                                    <div *ngIf="registerSubmitted && registerFormControls['password'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="registerFormControls['password'].errors['required']">
                                            Password is required
                                        </div>
                                        <div *ngIf="registerFormControls['password'].errors['minlength']">
                                            Password length should be atleast 6 digit.
                                        </div>
                                    </div>

                                    <div class="form_icon" style="top:10px"
                                       (click)="registerPassword.type=registerPassword.type=='password'?'text':'password'">
                                        <span toggle="#password-field"
                                            [ngClass]="registerPassword.type=='password'?'fa-eye-slash':'fa-eye'"
                                            class="fa fa-fw field-icon toggle-password"></span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="submit" class="btn btn-warning btn-block mb-2">
                                        Create Your Account
                                    </button>
                                    <label>By clicking you will be agreeing to
                                        <a href="" routerLink="/terms-conditions" target="_blank">
                                            Terms & Conditions</a> and you agree to be contacted by OneHome and others for similar properties or related services via WhatsApp, phone, sms, e-mail etc.
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- modal start-->
<div class="modal fade" id="SendEnquiryModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content feedback-popup">
            <div class="modal-header justify-content-center">
                <h5 class="modal-title text-center" id="exampleModalLabel">Send Enquiry</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form-box" [formGroup]="sendEnquiryForm">
                    <div class="login-white-box">
                        <div class="form-group">
                            <input type="text" (input)="preventSpecialChars($event)"
                               (paste)="onPaste($event)" class="form-ctrl form-control" formControlName="name"
                                placeholder="Name"
                                [ngClass]="{ 'is-invalid': enquirySubmitted && enquiryFormControls['name'].errors }"  [readonly]="true">
                            <div *ngIf="enquirySubmitted && enquiryFormControls['name'].errors"
                                class="invalid-feedback">
                                <div *ngIf="enquiryFormControls['name'].errors['required']">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-ctrl form-control" formControlName="email"
                                placeholder="Email"
                                [ngClass]="{ 'is-invalid': enquirySubmitted && enquiryFormControls['email'].errors }"  [readonly]="true">
                            <div *ngIf="enquirySubmitted && enquiryFormControls['email'].errors"
                                class="invalid-feedback">
                                <div *ngIf="enquiryFormControls['email'].errors['required']">
                                    Email is required.
                                </div>
                                <div *ngIf="enquiryFormControls['email'].errors['email']">
                                    Email should be valid.
                                </div>
                                <div *ngIf="enquiryFormControls['email'].errors['pattern']">
                                    Email should be valid.
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <input type="number" class="form-ctrl form-control" formControlName="mobile"
                                placeholder="Contact Number"
                                [ngClass]="{ 'is-invalid': enquirySubmitted && enquiryFormControls['mobile'].errors }"  [readonly]="true">
                            <div *ngIf="enquirySubmitted && enquiryFormControls['mobile'].errors"
                                class="invalid-feedback">
                                <div *ngIf="enquiryFormControls['mobile'].errors['required']">
                                    Mobile is required
                                </div>
                                <div *ngIf="enquiryFormControls['mobile'].errors['pattern']">
                                    Mobile No. should be valid.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control form-ctrl" rows="6" placeholder="Message"
                                formControlName="message" (input)="preventSpecialChars($event)"
                               (paste)="onPaste($event)"
                                [ngClass]="{ 'is-invalid': enquirySubmitted && enquiryFormControls['message'].errors }"></textarea>
                            <div *ngIf="enquirySubmitted && enquiryFormControls['message'].errors"
                                class="invalid-feedback">
                                <div *ngIf="enquiryFormControls['message'].errors['required']">
                                    Message is required
                                </div>
                            </div>
                        </div>
                        <div class="btn-width">
                            <button type="submit" [disabled]="isDisabledSendEnquiry" (click)="sendEnquiry()"
                                class="btn btn-warning btn-block">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal end -->


<!-- modal start -->
<div class="offcanvas offcanvas-top bidOtp-offcanvas" tabindex="-1" id="offcanvasForgotOtp"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="text-center otp-box">
                            <div class="title">
                                <h3>Submit OTP</h3>
                            </div>

                            <form [formGroup]="otpForm" (keyup.enter)="userId?register():verifyForgotOtp()">
                                <div class="form-group">
                                    <div class="otpinputBox">
                                        <input type="number" id="otp1" placeholder="0" (keyup)="nextStep($event,1)"
                                           (focus)="focused(1)" (paste)="paste($event)" maxLength="1"
                                            formControlName="otp1"
                                            onkeypress="if(this.value.length==1) return false; return event.keyCode === 8 || event.charCode >= 48 &amp; event.charCode <= 57;">
                                        <span>-</span>
                                        <input type="number" id="otp2" placeholder="0" (keyup)="nextStep($event,2)"
                                           (focus)="focused(2)" maxLength="1" formControlName="otp2"
                                            onkeypress="if(this.value.length==1) return false; return event.keyCode === 8 || event.charCode >= 48 &amp; event.charCode <= 57;">
                                        <span>-</span>
                                        <input type="number" id="otp3" placeholder="0" (keyup)="nextStep($event,3)"
                                           (focus)="focused(3)" maxLength="1" formControlName="otp3"
                                            onkeypress="if(this.value.length==1) return false; return event.keyCode === 8 || event.charCode >= 48 &amp; event.charCode <= 57;">
                                        <span>-</span>
                                        <input type="number" id="otp4" placeholder="0" (keyup)="nextStep($event,4)"
                                           (focus)="focused(4)" maxLength="1" formControlName="otp4"
                                            onkeypress="if(this.value.length==1) return false; return event.keyCode === 8 || event.charCode >= 48 &amp; event.charCode <= 57;">
                                            <span>-</span>
                                            <input type="number" id="otp5" placeholder="0" (keyup)="nextStep($event,5)"
                                           (focus)="focused(5)" maxLength="1" formControlName="otp5"
                                            onkeypress="if(this.value.length==1) return false; return event.keyCode === 8 || event.charCode >= 48 &amp; event.charCode <= 57;">
                                            <span>-</span>
                                            <input type="number" id="otp6" placeholder="0" (keyup)="nextStep($event,6)"
                                           (focus)="focused(6)" maxLength="1" formControlName="otp6"
                                            onkeypress="if(this.value.length==1) return false; return event.keyCode === 8 || event.charCode >= 48 &amp; event.charCode <= 57;">
                                    </div>
                                </div>
                                <div style="display: block;margin-top: -14px;margin-bottom: 8px;"
                                    *ngIf="otpFormSubmitted && otpFormControls['otp1'].errors || otpFormSubmitted && otpFormControls['otp2'].errors || otpFormSubmitted && otpFormControls['otp3'].errors || otpFormSubmitted && otpFormControls['otp4'].errors  
                                    || otpFormSubmitted && otpFormControls['otp5'].errors || otpFormSubmitted && otpFormControls['otp6'].errors"
                                    class="invalid-feedback">
                                    <div
                                        *ngIf="otpFormControls['otp1'].errors?.['required'] || otpFormControls['otp2'].errors?.['required'] || otpFormControls['otp3'].errors?.['required'] || otpFormControls['otp4'].errors?.['required']
                                        || otpFormControls['otp5'].errors?.['required'] || otpFormControls['otp6'].errors?.['required']">
                                        OTP is required.
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="button" *ngIf="!userId" (click)="verifyForgotOtp()"
                                        class="btn btn-warning">Submit</button>
                                    <button type="button" *ngIf="userId" (click)="register()"
                                        class="btn btn-warning">Submit</button>
                                </div>
                                <div class="form-group forgot-txt SignUp-txt text-center">
                                    <p>Didn’t receive code on phone or email?
                                        <a href="" *ngIf="!userId" (click)="sendOtp(true)">Resend
                                            OTP</a>
                                        <a href="" *ngIf="userId"
                                           (click)="registerSendOtp(true)">Resend
                                            OTP</a>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- modal end -->


<!--  Forgot Password offcanvas-->
<div class="offcanvas offcanvas-top login-offcanvas" tabindex="-1" id="offcanvasTopForgotPassword"
    aria-labelledby="offcanvasTopLabel">
    <div class="offcanvas-body">
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        <div class="form-box form-box-login">
            <div class="login-container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 wlcome-login">
                        <img src="assets/images/new_loginimg.webp" alt="Login Banner" />
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="login-white-box">
                            <div class="title">
                                <h3>Forgot Password</h3>
                            </div>
                            <form [formGroup]="otpForm">
                                <div class="form-group">
                                    <label>Password</label>
                                    <input #password1 type="password" class="form-ctrl form-control"
                                        formControlName="password" placeholder="Enter Password" autocomplete="current-password" 
                                        [ngClass]="{ 'is-invalid': otpFormSubmitted && otpFormControls['password'].errors }">
                                    <div *ngIf="otpFormSubmitted && otpFormControls['password'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="otpFormControls['password'].errors['required']">
                                            New Password is required.
                                        </div>
                                    </div>
                                    <div class="form_icon"
                                       (click)="password1.type=password1.type=='password'?'text':'password'">
                                        <span toggle="#password-field"
                                            [ngClass]="password1.type=='password'?'fa-eye-slash':'fa-eye'"
                                            class="fa fa-fw field-icon toggle-password"></span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Confirm Password</label>
                                    <input #password2 type="password" class="form-ctrl form-control"
                                        placeholder="Enter Confirm Password" formControlName="confirmPassword" autocomplete="new-password"
                                        [ngClass]="{ 'is-invalid': otpFormSubmitted && otpFormControls['confirmPassword'].errors }">
                                    <div *ngIf="otpFormSubmitted && otpFormControls['confirmPassword'].errors"
                                        class="invalid-feedback">
                                        <div *ngIf="otpFormControls['confirmPassword'].errors['required']">
                                            Confirm Password is required.
                                        </div>
                                        <div *ngIf="otpFormControls['confirmPassword'].errors['confirmedValidator']">New
                                            password and Confirm password must be match.</div>
                                    </div>
                                    <div class="form_icon"
                                       (click)="password2.type=password2.type=='password'?'text':'password'">
                                        <span toggle="#password-field"
                                            [ngClass]="password2.type=='password'?'fa-eye-slash':'fa-eye'"
                                            class="fa fa-fw field-icon toggle-password"></span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <a href="" (click)="submitForgotPassword()"
                                        class="btn btn-warning btn-block">Submit</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>